module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-advisor-bg.6d9da946.png";